import React from 'react';

export const VenturelabLogo: React.FC = () => (
  <div style={{ height: '55px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img
      src="/images/logos/VentureLAB-logo.png"
      alt="VentureLAB"
      width={200}
      height={55}
      className="dark:hidden"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
    <img
      src="/images/logos/VentureLAB-logo-dark.png"
      alt="VentureLAB"
      width={200}
      height={55}
      className="hidden dark:block"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
  </div>
);
